module.exports = __webpack_public_path__ + "img/142.98e971b4.jpg";